<template>
  <FormulateForm
    :name="formName"
    v-model="formValues"
    @submit="submit"
    class="bg-gray-100 py-4 px-6 mb-8"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      Add Domain
    </h3>

    <FormulateInput name="name" type="text" label="URL" validation="required" />
    <FormulateInput
      name="parameter_list"
      type="group"
      label="Tracking Parameters"
      :repeatable="true"
      add-label="+ Parameter"
    >
      <FormulateInput name="value" type="text" validation="required" />
    </FormulateInput>

    <FormulateErrors />

    <base-button type="submit" :loading="sending">
      {{ edit ? 'Save' : 'Add Domain' }}
    </base-button>
  </FormulateForm>
</template>

<script>
export default {
  props: {
    domain: Object,
  },
  data() {
    return {
      formName: `domainsForm${this.domain ? this.domain.id : ''}`,
      formValues: this.domain || {},
      sending: false,
    };
  },
  computed: {
    edit() {
      return Boolean(this.domain);
    },
  },
  methods: {
    async submit(data) {
      try {
        this.$formulate.resetValidation(this.formName);
        this.sending = true;
        const action = this.edit ? 'updateDomain' : 'addDomain';
        await this.$store.dispatch(`company/domain/${action}`, data);
        this.$emit('saved');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
